<script setup lang="ts">
import { ChevronLeft } from 'lucide-vue-next'
import { cn } from 'pejer/src/lib/utils'
import { useRouter } from 'vue-router'

// NOTE: if you are unlucky and get logged out when the
// cookie expires the back button will redirect you to the login page
const router = useRouter()

let props = defineProps<{
  header?: string
  subHeader?: string
  class?: string
  backButton?: boolean
  isSensitive?: boolean
}>()
</script>

<template>
  <div :class="cn('mb-2', props.class)">
    <div class="flex justify-between w-full gap-4">
      <div class="flex items-end shrink-0">
        <button
          v-if="props.backButton"
          class="flex items-center justify-center mr-4 p-2 rounded hover:bg-slate-100"
          @click="router.go(-1)"
        >
          <ChevronLeft :size="30" />
        </button>
        <div class="gap-1 flex flex-col">
          <h1
            :class="{
              'text-3xl': !props.subHeader,
              'text-xl': props.subHeader,
            }"
            class="font-bold"
          >
            <slot name="header">{{ header }}</slot>
          </h1>
          <h2 v-if="subHeader" :class="cn('text-3xl font-bold', 'sentry-mask')">{{ subHeader }}</h2>
        </div>
        <slot name="actions" />
      </div>
      <div class="flex items-end gap-4 justify-end min-h-full w-full"><slot /></div>
    </div>
  </div>
</template>

<style scoped></style>
